import i18next from 'i18next'
import React from 'react'
import { InView } from 'react-intersection-observer'
import { blockInviewHandler } from '../../../../utils/inview'
import { ComponentTeaserData } from '../../components/componentTeasers/componentTeasersState'
import { PageHeaderLayout } from '../../pageHeader/pageHeaderLayout'
import { SearchBarLayout } from '../../searchbar/searchBar.layout'

export const HeaderAndSearchBar = (props: {
  isSignupSuccessBannerShowing: boolean
  firstName: string
  firstNameLoaded: boolean
  componentOfTheDay?: ComponentTeaserData | 'loading'
  searchString: string
  setSearchString: (_: string) => void
}) => {
  return (
    <>
      {/* Pageheader */}
      {!props.isSignupSuccessBannerShowing && (
        <PageHeaderLayout
          kind="home-logged-in"
          title={i18next.t('home:loggedInPageheaderTitle', {
            firstName: props.firstName,
          })}
          firstNameLoaded={props.firstNameLoaded}
          componentOfTheDay={props.componentOfTheDay}
        />
      )}
      {/* Search bar */}
      <SearchBarLayout
        extraClasses="page__search"
        searchString={props.searchString}
        setSearchString={props.setSearchString}
        searchTab="components"
      />
    </>
  )
}

export const TextBlock = () => (
  <InView
    as="section"
    threshold={0}
    triggerOnce={true}
    onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
    className="block block--text"
  >
    <div className="block__inner container--m gutter--m">
      <div className="block__content">
        <div
          className="block__text maxwidth--s text--styled"
          dangerouslySetInnerHTML={{
            __html: i18next.t('home:loggedInPageheaderText'),
          }}
        />
      </div>
    </div>
  </InView>
)

export const DishBlogsWrapperLayout = (props: {
  children: React.ReactNode
}) => (
  <div className="page__dish-blogs-wrapper container--m gutter--m">
    {props.children}
  </div>
)
